module.exports = __webpack_public_path__ + "static/media/exam.bd891890.svg";